import moment from 'moment-timezone';
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

import renderIfChatAvailable from '../../../chat/renderIfChatAvailable';
import { branch, compose, renderNothing } from 'recompose';

const MessageClientButton = (props) => {
  const openChatWithAppointmentClient = (event) => {
    event.preventDefault();

    const {
            id,
            description,
            isRecurring,
            recurrEveryNumDays,
            start,
            end,
        } = props.appointment;
    const customer = props.appointment.customer;

    window.dispatchEvent(
        new CustomEvent('chat-open-conversation', {
          detail: {
            customerId: customer.id,
            firstName: customer.firstName,
            lastName: customer.lastName,
            appointment: {
              id,
              name: description,
              isRecurring,
              recurrEveryNumDays,
              dateTime: moment(start).toDate(),
              endTime: moment(end).toDate(),
            },
          },
        }),
    );
    props.onClose();
  };

  return <button className="c-customer-message-button" onClick={openChatWithAppointmentClient}>{t('appointment:actions.send_message')}</button>;
};

MessageClientButton.propTypes = {
  appointment: PropTypes.shape({
    canceledBy: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    isRecurring: PropTypes.bool,
    recurrEveryNumDays: PropTypes.number,
    start: PropTypes.string,
    end: PropTypes.string,
    customer: PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default compose(
    renderIfChatAvailable,
    branch(props => !moment(props.appointment.end).isSameOrAfter(), renderNothing),
)(MessageClientButton);
